import { Navigate, useLocation } from 'react-router-dom'
import type { PropsWithChildren } from 'react'
import { useAuthStore } from '../stores/auth'

export default function RequireAuth({ children }: Readonly<PropsWithChildren>){
  const { user, loading } = useAuthStore()
  const loc = useLocation()

  if (loading) return (
    <div className="flex items-center justify-center h-screen text-sm text-muted-foreground">
      Loading…
    </div>
  )

  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />
  return <>{children}</>
}